import stylesheet from './TextInput.scss?inline';
import {NXTInputField} from './InputField';

export class NXTTextInput extends NXTInputField {
    textInput: HTMLInputElement;
    cancelBtn: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get type(): string {
        return this.getAttribute('type') ?? 'text';
    }

    get variant(): string {
        return this.getAttribute('variant') ?? 'default';
    }

    public get value(): string {
        return this.textInput?.value;
    }

    public set value(value: string) {
        this.textInput.value = value;
    }

    public clear() {
        this.value = '';
    }

    get size(): string {
        return this.getAttribute('size') ?? 'md';
    }

    get cancelable(): boolean {
        return this.value && this.value.length > 0;
    }

    getSizeVariants(): string[] {
        const additionalClasses: string[] = [];
        additionalClasses.push(`text-input-${this.size}`);
        for (const breakpoint of ['md', 'lg', 'xl', 'xxl']) {
            const attributeName = `size-${breakpoint}`;
            if (this.hasAttribute(attributeName)) {
                additionalClasses.push(`text-input-${this.getAttribute(attributeName)}-${breakpoint}-up`);
            }
        }
        return additionalClasses;
    }

    protected renderControl(): HTMLElement {
        const container = document.createElement('div');
        container.classList.add('text-input', `variant-${this.variant}`, `type-${this.type}`, ...this.getSizeVariants(),);

        const slottedInputs = this.getSlotElements('input').filter(
            (el): el is HTMLInputElement => el instanceof HTMLInputElement,
        );

        if (slottedInputs.length > 0) {
            this.textInput = slottedInputs[0];
        } else {
            const textInput = document.createElement('input');
            textInput.setAttribute('type', this.type);
            if (this.hasAttribute('value')) {
                textInput.value = this.getAttribute('value');
            }
            if (this.hasAttribute('placeholder')) {
                textInput.placeholder = this.getAttribute('placeholder');
            }
            textInput.setAttribute('slot', 'input');
            this.appendChild(textInput);
            this.textInput = textInput;
        }

        const slot = document.createElement('slot');
        slot.setAttribute('name', 'input');
        container.appendChild(slot);

        this.wireInput(this.textInput, container);

        this.cancelBtn = document.createElement('span');
        this.cancelBtn.classList.toggle('cancel');
        this.cancelBtn.innerHTML = `<nxt-icon icon="close"></nxt-icon>`;
        container.appendChild(this.cancelBtn);

        if (this.cancelable) {
            container.classList.add('cancelable');
        }
        this.cancelBtn.addEventListener('click', () => {
            this.clear();
            container.classList.toggle('cancelable', this.cancelable);
            // Dispatch change event so listeners are notified of the clear action
            this.dispatchEvent(new Event('change', { bubbles: true }));
        });

        return container;
    }

    private wireInput(input: HTMLInputElement, container: HTMLElement) {
        input.addEventListener('blur', () => {
            input.classList.toggle('filled', !!input.value);
        });
        input.addEventListener('change', (ev) => {
            this.dispatchEvent(new Event(ev.type, ev));
        });
        input.addEventListener('keyup', () => {
            container.classList.toggle('cancelable', this.cancelable);
        });
    }

}

customElements.define('nxt-text-input', NXTTextInput);
